import { defineComponent, ComponentPublicInstance, createApp, reactive } from 'vue'
import TToast from './index.vue'
interface IToastParams {
    title: string | string[]
    timeout?: number
}

function createToast() {
    const state = reactive({
        isShow: TToast.props.modelValue.default,
        title: TToast.props.title.default,
        timeout: TToast.props.timeout.default,
    })
    let instance: ComponentPublicInstance | undefined = undefined
    const _toast = defineComponent({
        components: { TToast },
        setup() {
            return () => <t-toast v-model={state.isShow} title={state.title} timeout={state.timeout} />
        },
    })
    const show = (params: IToastParams) => {
        if (!instance) {
            const div = document.createElement('div')
            instance = createApp(_toast).mount(div)
            document.body.appendChild(instance.$el)
        }
        state.isShow = true
        state.title = params.title
        state.timeout = params.timeout
    }
    const hide = () => {
        state.isShow = false
        state.title = ''
    }

    return { show, hide }
}

export const toast = createToast()
